import { Box, Checkbox, Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import CustomTextField from "../components/CustomTextField";
import { useState } from "react";
import CustomButton from "../components/CustomButton";
import { Check } from "@mui/icons-material";
import { Helmet } from "react-helmet-async";

const ContactDoctors = () => {
  const [terminos, setTerminos] = useState(false);

  return (
    <>
      <Helmet>
        <title>Contacto para Médicos | Centro Médico Medam</title>

        <meta
          name="description"
          content="¿Eres médico y buscas integrarte a un hospital o conocer nuestras instalaciones? Contáctanos para recibir información sobre consultorios, servicios médicos, colaboración profesional y oportunidades en Centro Médico Medam."
        />

        <meta
          name="keywords"
          content="
          contacto para médicos,
          consultorios médicos Texcoco,
          renta de consultorios,
          hospital para médicos,
          colaboración médica,
          Centro Médico Medam,
          oportunidades para médicos,
          instalaciones médicas Estado de México
        "
        />

        <meta name="robots" content="index, follow" />

        <meta name="author" content="Centro Médico Medam" />

        <link
          rel="canonical"
          href="https://centromedicomedam.com/contacto-medicos"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Contacto para Médicos | Centro Médico Medam"
        />

        <meta
          property="og:description"
          content="Conoce nuestras instalaciones, servicios y oportunidades de colaboración profesional para médicos en Centro Médico Medam."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://centromedicomedam.com/contacto-medicos"
        />

        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Contacto para Médicos | Centro Médico Medam"
        />

        <meta
          name="twitter:description"
          content="Solicita información sobre consultorios, servicios y oportunidades de colaboración médica en Centro Médico Medam."
        />

        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />

        {/* Datos estructurados */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "Contacto para Médicos - Centro Médico Medam",
            url: "https://centromedicomedam.com/contacto-medicos",
            description:
              "Página de contacto para médicos interesados en conocer las instalaciones, servicios y oportunidades de colaboración profesional en Centro Médico Medam.",
            mainEntity: {
              "@type": "MedicalClinic",
              name: "Centro Médico Medam",
              telephone: "+52 595 957 0961",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Calpulalpan-Texcoco 105, Xala",
                addressLocality: "Texcoco de Mora",
                addressRegion: "Estado de México",
                postalCode: "56270",
                addressCountry: "MX",
              },
            },
          })}
        </script>
      </Helmet>
      <Grid container width="100%">
        <Grid size={design.Grid1} />
        <Grid container size={design.Grid10} pt={3}>
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Contacto para médicos"
            sx={design.Titulo}
          >
            Contacto para médicos
          </CustomText>
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Eres medico y quieres"
            sx={design.Description}
          >
            Eres medico y quieres más información acerca de nuestras
            instalaciones o servicios.
            <br />
            Llena le siguiente formulario y nos pondremos en contacto contigo
          </CustomText>
          <Grid container width="100%">
            <Grid size={design.Grid2} />
            <Grid container size={design.Grid8}>
              <CustomText
                variant="subtitle1"
                color="#2349D0"
                text="Datos personales"
                sx={design.Datos}
              >
                Datos personales
              </CustomText>

              <CustomTextField
                title="Nombre(s)"
                id="Escribe tu(s) nombre(s)"
                name="Escribe tu(s) nombre(s)"
                label="Escribe tu(s) nombre(s)"
                colorTitle="#333333"
                type="text"
                grid={4}
                gridXS={12}
                variant="outlined"
              />
              <CustomTextField
                title="Apellido(s)"
                id="Escribe tu(s) apellido(s)"
                name="Escribe tu(s) apellido(s)"
                label="Escribe tu(s) apellido(s)"
                colorTitle="#333333"
                type="text"
                grid={4}
                gridXS={12}
                variant="outlined"
              />
              <CustomTextField
                title="Apellido(s)"
                id="Escribe tu(s) apellido(s)"
                name="Escribe tu(s) apellido(s)"
                label="Escribe tu(s) apellido(s)"
                colorTitle="#333333"
                type="text"
                grid={4}
                gridXS={12}
                variant="outlined"
              />
              <CustomTextField
                title="Correo electrónico"
                id="Escribe tu correo electrónico"
                name="Escribe tu correo electrónico"
                label="Escribe tu correo electrónico"
                colorTitle="#333333"
                type="text"
                grid={12}
                gridXS={12}
                variant="outlined"
              />
              <CustomTextField
                title="Número telefónico"
                id="Escribe un numero donde contactarte"
                name="Escribe un numero donde contactarte"
                label="Escribe un numero donde contactarte"
                colorTitle="#333333"
                type="text"
                grid={12}
                gridXS={12}
                variant="outlined"
              />
              <CustomTextField
                title="Fecha de nacimiento"
                id=""
                name=""
                label=""
                colorTitle="#333333"
                type="date"
                grid={12}
                gridXS={12}
                variant="outlined"
              />
              <CustomTextField
                title="Mensaje"
                id="Escribe indicaciones especiales o información importante"
                name="Escribe indicaciones especiales o información importante"
                label="Escribe indicaciones especiales o información importante"
                colorTitle="#333333"
                type="text"
                grid={12}
                gridXS={12}
                variant="outlined"
              />

              <Box display="flex" alignItems="center" mb={5} mt={5}>
                <Checkbox
                  checked={terminos}
                  onChange={(e) => setTerminos(e.target.checked)}
                  color="primary"
                />
                <CustomText
                  variant="subtitle1"
                  color="#333333"
                  text="Consultorio"
                  sx={design.Descrip}
                >
                  He leído y acepto el{" "}
                  <a
                    href="/"
                    style={design.Redirec}
                    onMouseEnter={(e) =>
                      (e.target.style.textDecoration = "underline")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.textDecoration = "none")
                    }
                  >
                    Aviso de Privacidad
                  </a>{" "}
                  y{" "}
                  <a
                    href="/"
                    style={design.Redirec}
                    onMouseEnter={(e) =>
                      (e.target.style.textDecoration = "underline")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.textDecoration = "none")
                    }
                  >
                    Términos y Condiciones
                  </a>
                </CustomText>
              </Box>
              <CustomButton
                type="submit"
                variant="contained"
                color="success"
                colorTexto="#fff"
                backgroundColor="#489E4D"
                width="40%"
                height={45}
                borderRadius={10}
                gridXS={12}
                gridMD={12}
                grid={12}
                style={design.Shopping}
                align={true}
              >
                Mandar mensaje
                <Check
                  sx={{
                    fontSize: 20,
                  }}
                />
              </CustomButton>
            </Grid>
            <Grid size={design.Grid2} />
          </Grid>
        </Grid>
        <Grid size={design.Grid1} />
      </Grid>
    </>
  );
};
export default ContactDoctors;
const design = {
  Titulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 25,
      sm: 25,
      md: 40,
      lg: 40,
    },
    fontWeight: 700,
    lineHeight: "normal",
    textAlign: "center",
    paddingTop: 2,
    width: "100%",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    textAlign: "center",
    width: "100%",
    marginTop: 2,
  },
  Datos: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 26,
      lg: 26,
    },
    fontWeight: 700,
    lineHeight: "normal",
    textAlign: "center",
    width: "100%",
    marginTop: 5,
    marginBottom: 5,
  },
  Descrip: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 18,
    lineHeight: "normal",
    textAlign: "left",
  },
  Shopping: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    marginTop: 5,
  },
  Redirec: {
    textDecoration: "none",
    color: "#2349D0",
  },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid2: { xs: 1, md: 3, xl: 3, lg: 3 },
  Grid8: { xs: 10, md: 6, xl: 6, lg: 6 },
  Grid10: { xs: 10, md: 10, xl: 10, lg: 10 },
};
